// src/App.js

import React, { useMemo } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { clusterApiUrl } from '@solana/web3.js';
import Home from './pages/Home';
import OAuthCallback from './pages/OAuthCallback';
import DiscordCallback from './pages/DiscordCallback';
import ServerConfig from './pages/ServerConfig';
import PurchaseComponent from './components/PurchaseComponent';
import ProtectedSetupRoute from './components/ProtectedSetupRoute';
import NFTVerificationPage from './pages/NFTVerificationPage';
import DashboardLayout from './components/setupstyles/DashboardLayout'; // Import DashboardLayout
import CurrentConfigs from './components/CurrentConfigs';
import VerifyNFT from './pages/VerifyNFT';
import RedirectHandler from './components/RedirectHandler';
import VerifyWallet from './pages/VerifyWallet'; // New route
import './App.css';
import AuthProvider from './context/AuthContext'; // Default import
import '@solana/wallet-adapter-react-ui/styles.css'; // Retain only import

const AppWrapper = () => {
  const network = process.env.REACT_APP_SOLANA_NETWORK || 'devnet';
  const endpoint = useMemo(
    () => process.env.REACT_APP_SOLANA_RPC_URL || clusterApiUrl(network),
    [network]
  );

  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter({ network }),
    ],
    [network]
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <Router>
            <AuthProvider> {/* Move AuthProvider inside Router */}
              <Routes>
                {/* Single Route for "/" with RedirectHandler and Home */}
                <Route path="/" element={<Home />} />

                {/* New Route for Verify Wallet */}
                <Route path="/verify-wallet" element={<VerifyWallet />} />
                <Route path="/nft-verification-callback" element={<RedirectHandler />} />

                {/* Public Routes */}
	        <Route path="/login-callback" element={<RedirectHandler />} />
                <Route path="/oauth/callback" element={<RedirectHandler />} />
                <Route path="/purchase" element={<PurchaseComponent />} />

                {/* NFT Verification Route */}
                <Route path="/nft-verification" element={<NFTVerificationPage />} />

                {/* Dashboard Layout Routes */}
                <Route element={<DashboardLayout />}>
                  <Route 
                    path="/setup" 
                    element={
                      <ProtectedSetupRoute>
                        <ServerConfig />
                      </ProtectedSetupRoute>
                    } 
                  />
                  <Route 
                    path="/current-configs" 
                    element={
                      <ProtectedSetupRoute>
                        <CurrentConfigs />
                      </ProtectedSetupRoute>
                    } 
                  />
                </Route>

                {/* Fallback Route */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AuthProvider>
          </Router>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};

export default AppWrapper;


